import { createSlice } from '@reduxjs/toolkit';

import { api } from '../../api';

export const awsSlice = createSlice({
  name: 'aws',
  initialState: {
    aws : "",
    bucket : '',
    s3_filepath :'',
    access_key_id: "",
    secret_access_key :"",
  },
  reducers: {
    awsFetchStart(state) {
      state.loading = true;
      state.aws = '';
      state.error = null;
    },
    awsFetchSuccess(state, action) {
      state.loading = false;
      state.aws = action.payload;
    },
    awsFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    s3FetchSuccess(state, action) {
      state.loading = false;
      state.bucket = action.payload.bucket;
      state.s3_filepath = action.payload.s3_filepath;
      state.access_key_id = action.payload.access_key_id;
      state.secret_access_key = action.payload.secret_access_key;
    },
  },
});

export const {
  awsFetchStart, awsFetchSuccess, awsFetchFailed,s3FetchSuccess
} = awsSlice.actions;

export default awsSlice.reducer;

export const selectAwsLoading = state => state.aws.loading;
export const selectAwsSuccess = state => state.aws.aws;
export const selectS3Success = state => state.aws;


export const giveS3Access = (email, username, policyName, folderName) => async dispatch => {
  dispatch(awsFetchStart());
  try {
    await api('/api/create_policy', {
        email,
        username,
        policyName,
        folderName
      }, true);
   
    dispatch(awsFetchSuccess("S3 permission given successfully"));
  } catch (err) {
    dispatch(awsFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const updateS3Access = (email,  policyName, folderName) => async dispatch => {
  dispatch(awsFetchStart());
  try {
    await api('/api/update_policy', {
        email,
        policyName,
        folderName
      }, true);
   
    dispatch(awsFetchSuccess("S3 permission updated successfully"));
  } catch (err) {
    dispatch(awsFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const revokeS3Access = (email) => async dispatch => {
  dispatch(awsFetchStart());
  try {
    await api('/api/delete_policy', {
        email,
      }, true);
   
    dispatch(awsFetchSuccess("S3 permission Revoked."));
  } catch (err) {
    dispatch(awsFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};

export const getS3AccessCreds = () => async dispatch => {
  dispatch(awsFetchStart());
  try {
    const data = await api('/api/s3_creds', true);
   
    dispatch(s3FetchSuccess(data));
  } catch (err) {
    dispatch(awsFetchFailed({
      message: err.message,
      status: err.status,
    }));
  }
};